module.exports = __webpack_public_path__ + "static/juggling_hero-a3a2e016228e2495b4040f830536030e.jpg";